import React from 'react'
import styled, { css } from 'styled-components'
import { inheritPrimaryColor } from '../colors'

const DataCard = ({ children, year, ...props }) => {
  return (
    <Container target='_blank' {...props}>
      <LinkIconColumn>
        <i className='material-icons'>link</i>
      </LinkIconColumn>
      <ContentColumn>
        {children}
        <div css={css`color: ${inheritPrimaryColor}; font-size: 0.9em`}>{year}</div>
      </ContentColumn>
    </Container>
  )
}
const Container = styled.a`
  max-width: 300px;
  text-decoration: none;
  white-space: wrap;
  color: rgb(120, 120, 120);
  margin: 30px;
  display: flex;
  border: 1px solid transparent;
  transition: border-color 0.1s;
  border-radius: 3px;
  &:hover {
    border-color: ${inheritPrimaryColor}
  }
  &:hover > span {
    background-color: ${inheritPrimaryColor};
    color: white;
  }
`
const LinkIconColumn = styled.span`
  padding: 10px;
  transition: background-color 0.1s, color 0.1s;
`
const ContentColumn = styled.div`
  padding: 10px;
`

export default DataCard